export const parseISOToEpoch = (dateString) => {
    if (typeof Temporal !== "undefined" && Temporal.Instant) {
        try {
            const instant = Temporal.Instant.from(dateString);
            return instant.epochMicroseconds ?? instant.epochMilliseconds;
        } catch {
            // Fall through to Date for RFC 822 and other formats
        }
    }
    return new Date(dateString).getTime();
};
